export default __webpack_public_path__ + "static/char-s-17-kr-ab757ac397f2c11d16364a5bfe9f4c79.webp";